/*!
 * vue-tag v0.10.14 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { internalPropsMagicTransform } from '@aspectus/vue-utils';

var Tag = {
  name: 'tag',
  functional: true,
  props: {
    tag: {
      default: 'div'
    },
    enableVueTagPropsFix: Boolean
  },
  render: function render(h, context) {
    var _context$props = context.props,
        tag = _context$props.tag,
        enableVueTagPropsFix = _context$props.enableVueTagPropsFix;
    return h(tag, enableVueTagPropsFix ? internalPropsMagicTransform(tag, context.data) : context.data, context.children);
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? Tag.name : _ref$name;

  Vue.component(name, Tag);
}
var main = {
  install: install
};

export default main;
export { Tag, install };
